// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WM","chargeSummarySection":"XM","absolute":"YM","relative":"ZM","fixed":"_M"};